(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["provider-coverage"]) return;
  try {
    
  function updateProviderIntroduction(section, incoming) {
    if (incoming && incoming.dataset.providerKey !== section.dataset.providerKey) return;
    const destinations = section.querySelector('[data-provider-intro-destinations]');
    if (incoming) {
      section.dataset.providerScenario = String(Number(section.dataset.providerScenario) | Number(incoming.dataset.providerScenario));
      const seen = new Set([...destinations.querySelectorAll('[data-coverage-destination]')].map(item => item.dataset.coverageDestination));
      incoming.querySelectorAll('[data-provider-intro-destinations] [data-coverage-destination]').forEach(item => {
        if (!seen.has(item.dataset.coverageDestination)) {
          destinations.append(document.importNode(item, true));
          seen.add(item.dataset.coverageDestination);
        }
      });
    }
    const scenario = section.dataset.providerScenario;
    const fragment = section.querySelector(`[data-provider-intro-template="${scenario}"]`).content.cloneNode(true);
    const items = [...destinations.querySelectorAll('[data-coverage-destination]')].sort((a,b) => a.dataset.coverageDestination.localeCompare(b.dataset.coverageDestination));
    fragment.querySelectorAll('[data-intro-destination-slot]').forEach(slot => {
      const list = document.createDocumentFragment();
      items.forEach((item,index) => {
        if (index) list.append(document.createTextNode(index === items.length - 1 ? ' and ' : ', '));
        list.append(item.cloneNode(true));
      });
      slot.replaceWith(list);
    });
    const output = section.querySelector('[data-provider-intro-output]');
    output.replaceChildren(fragment);
    output.hidden = false;
  }
  document.addEventListener('provider:page-loaded', event => {
    const incoming = event.detail.documentPage.querySelector('[data-provider-coverage]');
    if (!incoming) return;
    document.querySelectorAll('[data-provider-coverage]').forEach(section => {
      if (section.dataset.providerKey === event.detail.providerKey) updateProviderIntroduction(section, incoming);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["provider-plans"]) return;
  try {
    
  function sortProviderPlans(grid) {
    const cards = [...grid.querySelectorAll('[data-provider-product]')];
    cards.sort((a, b) => Number(a.dataset.coverageOrder) - Number(b.dataset.coverageOrder));
    grid.append(...cards);
  }
  async function loadProviderPages(section) {
    if (section.dataset.loading === 'true') return;
    section.dataset.loading = 'true';
    const grid = section.querySelector('[data-provider-grid]');
    const pagination = section.querySelector('[data-provider-pagination]');
    const seen = new Set([...grid.querySelectorAll('[data-provider-product]')].map(card => card.dataset.providerProduct));
    let next = section.querySelector('[data-provider-next]');
    const visited = new Set();
    try {
      while (next) {
        const url = new URL(next.dataset.url, window.location.origin);
        if (url.origin !== window.location.origin || visited.has(url.href)) break;
        visited.add(url.href);
        const response = await fetch(url.href);
        if (!response.ok) throw new Error('Provider page unavailable');
        const documentPage = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextSection = documentPage.querySelector('[data-provider-section]');
        if (!nextSection || nextSection.dataset.providerKey !== section.dataset.providerKey) throw new Error('Unexpected provider page');
        nextSection.querySelectorAll('[data-provider-product]').forEach(card => {
          if (!seen.has(card.dataset.providerProduct)) {
            seen.add(card.dataset.providerProduct);
            grid.appendChild(document.importNode(card, true));
          }
        });
        sortProviderPlans(grid);
        document.dispatchEvent(new CustomEvent('provider:page-loaded', { detail: { providerKey: section.dataset.providerKey, documentPage } }));
        pagination.innerHTML = nextSection.querySelector('[data-provider-pagination]').innerHTML;
        next = pagination.querySelector('[data-provider-next]');
      }
      pagination.hidden = true;
      const emptyMessage = section.querySelector('[data-provider-empty-message]');
      if (emptyMessage) emptyMessage.hidden = seen.size > 0;
      if (seen.size === 0) {
        let robots = document.head.querySelector('meta[name="robots"]');
        if (!robots) {
          robots = document.createElement('meta');
          robots.name = 'robots';
          document.head.appendChild(robots);
        }
        robots.content = 'noindex, follow';
      }
    } catch (error) {
      pagination.hidden = false;
    }
  }
  function initializeProviderPages(root = document) {
    root.querySelectorAll('[data-provider-section]').forEach(section => {
      if (section.querySelector('[data-provider-next]')) loadProviderPages(section);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeProviderPages());
  else initializeProviderPages();
  document.addEventListener('shopify:section:load', event => initializeProviderPages(event.target));
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-provider-next][data-url]');
    if (!button) return;
    const url = new URL(button.dataset.url, window.location.origin);
    if (url.origin === window.location.origin) window.location.assign(url.href);
  });

  } catch(e) { console.error(e); }
})();
})();
